<template>
  <section class="container our-services" id="az-offie-elonyei">
    <h2 class="h3" v-animate-in>
      A Te megbízásod. A mi szenvedélyünk.
    </h2>
    <p v-animate-in>
      Tapasztald meg személyes megközelítésünket, mély piaci ismereteinket és
      teljes körű támogatásunkat az irodabérlési folyamat során. A tökéletes
      helyiség megtalálásának kihívását stresszmentes élménnyé alakítjuk. Bízz
      tapasztalt szakembereinkben, akik a legjobb döntésekhez vezetnek.
    </p>
    <ol
      class="toggle-content"
      v-animate-in
      ref="toggleContent"
      :class="{ init: init, mobile: isMobile() }"
    >
      <li class="toggle-content-item white" :class="{ active: active === 1 }">
        <div class="card" @click.prevent.stop="toggleActive(1)">
          <div class="card-head">
            <div class="card-head-left">
              <div class="num">1</div>
              <h3>Spórolj időt és pénzt</h3>
            </div>
            <div class="card-head-right">
              <img
                src="@/assets/page-1.png"
                width="220"
                height="213"
                alt="Spórolj időt és pénzt"
                title=""
              />
            </div>
          </div>
          <div class="card-body">
            <div class="content">
              <p>
                Az irodakeresés időigényes. Bízd ránk a keresést, hogy a
                megtakarított időt, pénzt és energiát vállalkozásid
                fejlesztésére fordíthasd.
              </p>
            </div>
          </div>
          <div class="toggle">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11"
                cy="11"
                r="10.4"
                stroke="currentColor"
                stroke-width="1.2"
              />
              <path
                d="M6 11H16"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
              />
              <path
                d="M11 16V6"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </li>
      <li class="toggle-content-item black" :class="{ active: active === 2 }">
        <div class="card" @click.prevent.stop="toggleActive(2)">
          <div class="card-head">
            <div class="card-head-left">
              <div class="num">2</div>
              <h3>Szerezz tárgyalási előnyt</h3>
            </div>
            <div class="card-head-right">
              <img
                src="@/assets/page-2.png"
                width="241"
                height="229"
                alt="Szerezz tárgyalási előnyt"
                title=""
              />
            </div>
          </div>
          <div class="card-body">
            <div class="content">
              <p>
                Az irodapiacon szerzett két évtizedes tapasztalatunkra
                támaszkodva, a piaci kockázatok és az előnyös szerződési
                feltételek átfogó ismeretével felvértezve szakszerűen vezetjük
                at ügyfeleinket az irodabérlés folyamatán.
              </p>
            </div>
          </div>
          <div class="toggle">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11"
                cy="11"
                r="10.4"
                stroke="currentColor"
                stroke-width="1.2"
              />
              <path
                d="M6 11H16"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
              />
              <path
                d="M11 16V6"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </li>
      <li class="toggle-content-item color" :class="{ active: active === 3 }">
        <div class="card" @click.prevent.stop="toggleActive(3)">
          <div class="card-head">
            <div class="card-head-left">
              <div class="num">3</div>
              <h3>Dolgozz hatékonyabban</h3>
            </div>
            <div class="card-head-right">
              <img
                src="@/assets/page-3.png"
                width="260"
                height="229"
                alt="Dolgozz hatékonyabban"
                title=""
              />
            </div>
          </div>
          <div class="card-body">
            <div class="content">
              <p>
                Szakértőink segítenek felmérni vállalatod pontos irodahasználati
                igényeit, hogy ne csupán egy jó irodát, de egy produktív
                munkahelyet hozhass létre.
              </p>
            </div>
          </div>
          <div class="toggle">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11"
                cy="11"
                r="10.4"
                stroke="currentColor"
                stroke-width="1.2"
              />
              <path
                d="M6 11H16"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
              />
              <path
                d="M11 16V6"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </li>
    </ol>
  </section>
</template>

<script>
export default {
  name: "OurServices",
  data() {
    return {
      init: false,
      active: 1,
      height: "auto",
      isUserScrolling: false,
      prevScrollY: 0,
      prevWidth: window.innerWidth
    };
  },
  methods: {
    toggleActive(index) {
      // if (this.isUserScrolling) return
      if (this.active === index) {
        //this.active = 0;
      } else {
        this.active = index;
      }
    },
    isMobile() {
      if (screen.width <= 500) {
        return true;
      } else {
        return true;
      }
    },
    sizingContent(e, force = false) {
      if (!force && Math.abs(this.prevWidth - window.innerWidth) === 0) return;
      this.prevWidth = window.innerWidth;
      this.scrollCheck();
      if (this.isUserScrolling) return;
      this.init = false;
      this.$refs.toggleContent.style.height = "auto";
      let bodys = this.$refs.toggleContent.querySelectorAll(".card .card-body");
      setTimeout(() => {
        bodys.forEach(element => {
          //element.tr = element.style.transition;
          //element.style.transition = "none";
          element.style.height = "auto";
        });
        if (this.isMobile()) {
          bodys.forEach(element => {
            // console.log(element.offsetHeight, element);
            element.style.height = element.offsetHeight + "px";
            //element.style.transition = element.tr;
          });
        } else {
          this.height = 0;
          this.$refs.toggleContent
            .querySelectorAll(".card")
            .forEach(element => {
              if (this.height < element.offsetHeight) {
                this.height = element.offsetHeight;
              }
            });
          this.$refs.toggleContent.style.height = this.height + "px";
        }
        this.init = true;
      }, 400);
    },
    scrollCheck() {
      this.isUserScrolling = Math.abs(this.prevScrollY - window.scrollY) > 0;
      //console.log(this.isUserScrolling);
      this.prevScrollY = window.scrollY;
    }
  },
  mounted() {
    window.addEventListener("resize", this.sizingContent, true);
    window.addEventListener("scroll", this.scrollCheck, true);
    this.sizingContent(null, true);
  },
  unmounted() {
    window.removeEventListener("resize", this.sizingContent, true);
    window.removeEventListener("scroll", this.scrollCheck, true);
  }
};
</script>

<style lang="scss">
.our-services {
  margin-top: -100px !important;
  padding-top: 100px !important;
  h2 {
    margin-bottom: 16px;
  }
  .toggle-content {
    counter-reset: content;
    padding: 0;
    margin: 0;
    display: block;
    height: 100%;
    margin-bottom: 120px;
    &.init {
      .toggle-content-item {
        transition: flex 0.3s ease-out;
        &.active {
          .card-body {
            opacity: 1;
            animation-name: none;
            height: auto;
          }
        }
        .card-body {
          transition: all 0.3s ease-out;
          overflow: hidden;
        }
        &:not(.active) {
          .card-body {
            height: 0 !important;
          }
        }
      }
    }
    &-item {
      display: block;
      counter-increment: content;
      position: relative;
      // overflow: hidden;
      flex: 0 0 25%;
      width: 100%;
      // height: 100%;
      // color: $black;
      cursor: pointer;
      transition: none;
      &.color .card,
      &.black .card {
        width: 100%;
        border-radius: 0 0 22px 22px;
        padding: 46px 24px 24px 24px;
        margin: -22px 0 0 0;
      }
      &.white .card {
        .card-body {
          // color: $gray;
        }
        .card-head-left {
          .num {
            background: $black;
            color: $white;
          }
          h3 {
            color: $black;
          }
        }
      }
      &.color .card {
        z-index: 1;
        // background: $blue;
        background: $gradient;
        color: $white !important;
        .card-head-left {
          .num {
            background: $black;
            color: $white;
          }
        }
      }
      &.black .card {
        z-index: 2;
        background: $black;
        color: $white !important;
        .card-head-left {
          .num {
            background: $white;
            color: $black;
          }
        }
      }
      &.black .card,
      &.color .card {
      }
      &.active {
        width: 100%;
        cursor: auto;
        // z-index: 10;
        // flex: 0 0 50%;
        .toggle svg path:nth-child(3) {
          display: none;
        }
        .card {
          &-head {
            &-right {
              img {
                opacity: 1;
              }
            }
          }
        }
      }

      .card {
        position: relative;
        display: flex;
        flex-direction: column;
        z-index: 3;
        height: 100%;
        width: 100%;
        max-height: 100%;
        background: $white;
        border-radius: 22px;
        box-sizing: border-box;
        padding: 24px;
        user-select: none;
        &-head {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          &-left {
            .num {
              display: flex;
              justify-content: center;
              background: $black;
              color: $white;
              border-radius: 50%;
              width: 22px;
              height: 22px;
              font-size: 16px;
              line-height: 26px;
              font-weight: 600;
              font-style: normal;
              margin-bottom: 8px;
            }
            h3 {
              font-family: $title;
              font-size: 24px;
              line-height: 32px;
              font-weight: 400;
              margin: 0 0 22px;
            }
          }
          &-right {
            text-align: center;
            pointer-events: none;
            margin: auto 0 -120px;
            img {
              display: inline-block;
              max-width: 110px;
              height: auto;
              opacity: 0;
              transition: all 0.3s ease-out;
            }
          }
        }
        &-body {
          width: 100%;
          pointer-events: none;
          .content {
            padding: 136px 0 24px;
            font-weight: 300;
            p {
              font-size: 19px;
              line-height: 22px;
              margin: 0 0 16px;
            }
            ul {
              list-style: none;
              padding: 0;
              li {
                position: relative;
                font-size: 19px;
                line-height: 22px;
                padding: 0 0 0 24px;
                margin-bottom: 8px;
                &:before {
                  content: "";
                  position: absolute;
                  left: 8px;
                  top: 8px;
                  background: currentColor;
                  border-radius: 50%;
                  overflow: hidden;
                  width: 4px;
                  height: 4px;
                  display: inline-block;
                }
              }
            }
          }
        }
      }
    }
    .toggle {
      width: 70px;
      height: 70px;
      position: absolute;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
    }
  }

  @media screen and (min-width: $breakpoint) {
    margin-top: -100px !important;
    padding-top: 200px !important;
    .toggle-content {
      display: flex;
      max-width: 100%;
      flex-direction: row;
      margin-bottom: 100px;
      &-item {
        flex: 0 0 22%;
        .card {
          overflow: hidden;
          &-head {
            // height: 200px;
            flex-direction: row;
            justify-content: space-between;
            &-left {
              width: 100%;
              h3 {
                animation-name: titleoutinback;
                animation-duration: 0.6s;
                margin-bottom: 32px;
                // transition: opacity 0.3s ease-in 0s;
              }
            }
            &-right {
              margin: 0;
              text-align: center;
              position: relative;
              img {
                position: absolute;
                right: 0;
                //top: 24px;
                top: 0;
                margin-bottom: -16px;
                min-width: 110px;
                //width: 0;
                opacity: 0;
                height: auto;
                transition: all 0.3s ease-in 0s;
              }
            }
          }
          &-body {
            transition: none;
            .content {
              min-width: 460px;
              padding: 0 110px 24px 0;
            }
          }
        }
        &.active {
          flex: 0 0 56%;
          .card {
            &-head {
              &-left {
                //width: calc(100% - 160px);
                max-width: 380px;

                h3 {
                  animation-name: titleoutin;
                  animation-duration: 0.6s;
                  animation-fill-mode: forwards;
                }
              }
              &-right {
                img {
                  width: 100%;
                  opacity: 1;
                  top: 0;
                  transition: all 0.3s ease-out 0.3s;
                }
              }
            }
          }
        }
        &.color .card,
        &.black .card {
          width: calc(100% + 22px);
          border-radius: 0 22px 22px 0;
          padding: 24px 24px 24px 46px;
          margin: 0 0 0 -22px;
        }
        &.black .card {
        }
      }

      &.init {
        .toggle-content-item {
          transition: flex 0.3s ease-out;
          &.active {
            .card-body {
              animation-name: textin;
              width: 575px;
              opacity: 1;
            }
            .card {
              transition: all 0.3s ease-out 0.3s;
            }
          }
          &:not(.active) {
            // flex: 0 0 25%;
            .card-body {
              height: auto !important;
              width: 0;
              min-width: 0;
              //opacity: 0;
            }
          }
          .card-body {
            width: 0;
            animation-name: textout;
            animation-duration: 0.6s;
            animation-fill-mode: forwards;
          }
        }
      }
    }
  }
  @keyframes titleoutin {
    0% {
      opacity: 1;
      max-width: 200px;
    }

    50% {
      opacity: 0;
      max-width: 200px;
    }

    55% {
      opacity: 0;
      max-width: none;
    }
    60% {
      opacity: 1;
      max-width: none;
    }

    100% {
      opacity: 1;
      max-width: none;
    }
  }
  @keyframes titleoutinback {
    0% {
      opacity: 1;
      max-width: 380px;
    }

    50% {
      opacity: 0;
      max-width: 380px;
    }

    55% {
      opacity: 0;
      max-width: 200px;
    }

    60% {
      opacity: 0;
      max-width: 200px;
    }

    100% {
      opacity: 1;
      max-width: 200px;
    }
  }
  @keyframes textin {
    0% {
      opacity: 0;
    }

    30% {
      opacity: 0;
    }

    70% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  @keyframes textout {
    0% {
      opacity: 0.5;
    }

    30% {
      opacity: 0;
    }

    70% {
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }
}
</style>
